import styled from "styled-components";
import Button from "module-common/Button";

const AddButton = styled(Button).attrs({ size: "small", color: "green" })`
  align-self: flex-start;
`;
export default AddButton;



// WEBPACK FOOTER //
// ./src/module-supervisor-setting/common/AddButton.js